<template>
    <div id="main-container" class="px-0">
        <nav id="navbar-container" class="navbar navbar-expand-lg fixed-top navbar-scroll">
            <slot name="navbar"></slot>
        </nav>
        <div id="scrollable-container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContainerLayout',
    data() {
        return {
            //
        };
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        // 
    },
    mounted() {
        this.resizePage();
        window.addEventListener('resize', () => {
            this.resizePage();
        })

        window.addEventListener("scroll", () => {
            var curr = document.documentElement.scrollTop || document.body.scrollTop || 0;

            if (curr > 0) {
                document.getElementById('navbar-container').classList.add('scrolled');
            } else {
                document.getElementById('navbar-container').classList.remove('scrolled');
            }
        });
    },
    beforeUnmount() {
        window.removeEventListener('resize', () => {
            this.resizePage();
        })
    },
    methods: {
        resizePage() {
            if (document.getElementById('main-container')) {
                let deviceWidth = window.matchMedia("(max-width: 1024px)");
                if (deviceWidth.matches) {
                    document.getElementById('main-container').style.height = window.innerHeight + 'px';
                } else {
                    document.getElementById('main-container').style.height = '100vh';
                }

                if (document.getElementById('navbar-container') && document.getElementById('scrollable-container')) {
                    let mainContainerHeight = document.getElementById('main-container').offsetHeight;
                    // let navbarContainerHeight = document.getElementById('navbar-container').offsetHeight;

                    document.getElementById('scrollable-container').style.minHeight = mainContainerHeight + 'px';
                    // document.getElementById('scrollable-container').style.paddingTop = navbarContainerHeight + 'px';
                }
            }
        }
    },
    created() {
        //
    },
};
</script>

<style scoped>
#navbar-container {
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    background-color: var(--topbar-bg-color);
}

.scrolled {
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>